export const PATH_LOGOS = "https://imob86.concept.inf.br/logos/";

export const PATH_IMAGENS_SITE = "https://imob86.concept.inf.br/imagensSite/";

export const AREA_PESQUISA_IMOVEL = [
  { label: "Até 50m²", data: "50" },
  { label: "Entre 51m² e 100m²", data: 51 },
  { label: "Entre 101m² e 150m²", data: 101 },
  { label: "Entre 151m² e 200m²", data: 151 },
  { label: "Entre 201m² e 250m²", data: 201 },
  { label: "Entre 251m² e 300m²", data: 251 },
  { label: "Acima de 300m²", data: 300 }
]

export const ESTADOS = [
	{ sigla: "AC", id: 3, pais: { id: 1 }, nome:"Acre" },
	{ sigla: "AL", id: 4, pais: { id: 1 }, nome:"Alagoas" },
	{ sigla: "AM", id: 6, pais: { id: 1 }, nome:"Amazonas" },
	{ sigla: "AP", id: 5, pais: { id: 1 }, nome:"Amapá" },
	{ sigla: "BA", id: 7, pais: { id: 1 }, nome:"Bahia" },
	{ sigla: "CE", id: 8, pais: { id: 1 }, nome:"Ceará" },
	{ sigla: "DF", id: 9, pais: { id: 1 }, nome:"Distrito Federal" },
	{ sigla: "ES", id: 10, pais: { id: 1 }, nome:"Espírito Santo" },
	{ sigla: "GO", id: 11, pais: { id: 1 }, nome:"Goiás" },
	{ sigla: "MA", id: 2, pais: { id: 1 }, nome:"Maranhão" },
	{ sigla: "MG", id: 14, pais: { id: 1 }, nome:"Minas Gerais" },
	{ sigla: "MS", id: 13, pais: { id: 1 }, nome:"Mato Grosso do Sul" },
	{ sigla: "MT", id: 12, pais: { id: 1 }, nome:"Mato Grosso" },
	{ sigla: "PA", id: 15, pais: { id: 1 }, nome:"Pará" },
	{ sigla: "PB", id: 16, pais: { id: 1 }, nome:"Paraíba" },
	{ sigla: "PE", id: 18, pais: { id: 1 }, nome:"Pernambuco" },
	{ sigla: "PI", id: 1, pais: { id: 1 }, nome:"Piauí" },
	{ sigla: "PR", id: 17, pais: { id: 1 }, nome:"Paraná" },
	{ sigla: "RJ", id: 19, pais: { id: 1 }, nome:"Rio de Janeiro" },
	{ sigla: "RN", id: 20, pais: { id: 1 }, nome:"Rio Grande do Norte" },
	{ sigla: "RO", id: 22, pais: { id: 1 }, nome:"Rondônia" },
	{ sigla: "RR", id: 23, pais: { id: 1 }, nome:"Roraima" },
	{ sigla: "RS", id: 21, pais: { id: 1 }, nome:"Rio Grande do Sul" },
	{ sigla: "SC", id: 24, pais: { id: 1 }, nome:"Santa Catarina" },
	{ sigla: "SE", id: 26, pais: { id: 1 }, nome:"Sergipe" },
	{ sigla: "SP", id: 25, pais: { id: 1 }, nome:"São Paulo" },
	{ sigla: "TO", id: 27, pais: { id: 1 }, nome:"Tocantins" },
	{ sigla: "MA", id: 28,  pais: { id: 2 }, nome: "Massachusetts" }
]

export const PAISES = [
	{ sigla: "BR", id: 1, nome: "Brasil" },
	{ sigla: "US", id: 2, nome: "Estados Unidos" }
]

export const ZONAS = [
	
    { label: "Norte", data: "NORTE" },
    { label: "Sul", data: "SUL" },
    { label: "Sudeste", data: "SUDESTE" },
    { label: "Leste", data: "LESTE" },
    { label: "Oeste", data: "OESTE" },
	{ label: "Centro", data: "CENTRO"},
	{ label: "Não Informado", data: "NAO_INFORMADO"}
    
]
export const TIPOS_IMOVEIS = [
	{ nome: "Apartamento", id: 1 },
	{ nome: "Casa Comercial", id: 2 },
	{ nome: "Casa em Condomínio", id: 3 },
	{ nome: "Casa Residencial", id: 4 },
	{ nome: "Fazenda", id: 17 },
	{ nome: "Flat/Apart Hotel", id: 5 },
	{ nome: "Galpão", id: 6 },
	{ nome: "Garagem/Estacionamento", id: 16 },
	{ nome: "Hotel/Motel", id: 15 },
	{ nome: "Lote em Condomínio", id: 12 },
	{ nome: "Loja Comercial", id: 19 },
	{ nome: "Loja/Sala Comercial", id: 7 },
	{ nome: "Lote/Terreno", id: 8 },
	{ nome: "Ponto Comercial", id: 11 },
	{ nome: "Prédio Comercial", id: 14 },
	{ nome: "Quiosque", id: 13 },
	{ nome: "Quitinete", id: 9 },
	{ nome: "Sala Comercial", id: 18 },
	{ nome: "Sítio/Chácara", id: 10 }
];

export const CATEGORIAS_VENDA = [
	{ label: "Imóvel Avulso", data: "IMOVEL_AVULSO" },
	{ label: "Lançamento", data: "LANCAMENTO" }
];

export const FILTROS_DASHBOARD = [
	{ label: "Com Foto", data: "IMOVEIS_COM_FOTO" },
	{ label: "Sem Foto", data: "IMOVEIS_SEM_FOTO" },
	{ label: "Captados - Mês Atual", data: "IMOVEIS_CAPTADOS" },
	{ label: "Vendidos - Mês Atual", data: "IMOVEIS_VENDIDOS" },
	{ label: "Com Localização", data: "IMOVEIS_COM_LOCALIZACAO" },
	{ label: "Sem Localização", data: "IMOVEIS_SEM_LOCALIZACAO" }
];

export const STATUS_VENDA = [
  { label: "Disponível", data: "DISPONIVEL" },
	{ label: "Indisponível", data: "INDISPONIVEL" },
  { label: "Vendido", data: "VENDIDO" },
  { label: "Reservado", data: "RESERVADO" },
	{ label: "Arquivado", data: "ARQUIVADO" }
];

export const STATUS_CONTRATO = [
  { label: "Pendente", data: "PENDENTE" },
  { label: "Aprovado", data: "APROVADO" },
  { label: "Cancelado", data: "CANCELADO" }
];

export const STATUS_CONTRATO_ALUGUEL = [
  { label: "Pendente", data: "PENDENTE" },
	{ label: "Aprovado", data: "APROVADO" },
	{ label: "Desocupação", data: "EM_DESOCUPACAO" },
	{ label: "Finalizado", data: "FINALIZADO" },
	{ label: "Arquivado", data: "ARQUIVADO" }
];

export const STATUS_IMOVEL_ALUGUEL = [
	{ label: "Disponível", data: "DISPONIVEL" },
	{ label: "Reservado", data: "RESERVADO" },
	{ label: "Indisponível", data: "INDISPONIVEL" },
	{ label: "Locado", data: "LOCADO" },
	{ label: "Em Desocupação", data: "EM_DESOCUPACAO" },
	{ label: "Arquivado", data: "ARQUIVADO" }
  ];

export const OPERACAO_IMOVEL = [
	{ label: "Aluguel", data: "ALUGUEL" },
	{ label: "Venda", data: "VENDA" }
]

export const POSSE_CHAVE = [
  { label: "Proprietário", data: "PROPRIETARIO" },
  { label: "Imobiliária", data: "IMOBILIARIA" },
  { label: "Outro", data: "OUTRO" }
]

export const AUTORIZACAO_VENDA = [
  { label: "Escrita", data: "ESCRITA" },
  { label: "Verbal", data: "VERBAL" }
]

export const AUTORIZACAO_PLACA = [
  { label: "Colocação de placa permitida pelo proprietário", data: "PERMITIDO" },
  { label: "Proprietário não permitiu colocar placa", data: "PROPRIETARIO_NAO_PERMITIU" },
  { label: "Não é possível colocar placa", data: "NAO_PODE_COLOCAR_PLACA" }
]

export const OCORRENCIA_RETIRADA_PLACA = [
  { label: "Placa Retirada", data: "RETIRADA" },
  { label: "Placa Extraviada", data: "EXTRAVIADA" }
]

export const DURACAO_RESERVA = [
	{label: "6 horas", data: "6"},
	{label: "12 horas", data: "12"},
	{label: "24 horas", data: "24"},
	{label: "36 horas", data: "36"},
	{label: "48 horas", data: "48"},
	{label: "10 dias", data: "240"},
	{label: "15 dias", data: "360"},
	{label: "30 dias", data: "720"}
]

export const DURACAO_PRORROGACAO = [
	{label: "6 horas", data: "6"},
	{label: "12 horas", data: "12"},
	{label: "1 dia", data: "24"},
	{label: "2 dias", data: "48"},
	{label: "5 dias", data: "120"},
	{label: "7 dias", data: "168"}
]

export const BANCOS_HOMOLOGADOS_API = [
	"ASAAS",
	"CORA"
]

export const BANCOS_HOMOLOGADOS = [
	{label:"", data:""},
	{label:"Asaas", data: "ASAAS" },
	{label:"Banco do Brasil", data:"BANCO_DO_BRASIL"},
	{label:"Banco BTG Pactual", data: "BANCO_BTG_PACTUAL"},
	{label:"Bradesco", data:"BRADESCO"},	
	{label:"Caixa Econômica", data:"CAIXA_ECONOMICA"},
	{label:"Cora", data: "CORA"},
	{label:"Inter", data:"INTER"},
	{label:"Itaú", data:"ITAU"},
	{label:"Santander", data:"SANTANDER"},
	{label:"SICOOB", data:"SICOOB"},
	{label:"Sicredi", data:"SICRED"},
]

export const BANCOS_IMOBILIARIA = [
	{label:"", data:""},
	{label:"Asaas", data: "ASAAS" },
	{label:"Banco do Brasil", data:"BANCO_DO_BRASIL"},
	{label:"Banco BTG Pactual", data: "BANCO_BTG_PACTUAL"},
	{label:"Bradesco", data:"BRADESCO"},
	{label:"Banco do Nordeste", data:"BANCO_DO_NORDESTE"},
	{label:"Caixa Econômica", data:"CAIXA_ECONOMICA"},
	{label:"Cora", data: "CORA"},
	{label:"Inter", data:"INTER"},
	{label:"Itaú", data:"ITAU"},
	{label:"Nubank", data:"NUBANK"},
	{label:"Santander", data:"SANTANDER"},
	{label:"SICOOB", data:"SICOOB"},
	{label:"Sicredi", data:"SICRED"},
]

export const BANCOS = [
	{label:"Asaas", data: "ASAAS" },
	{label:"Bancoob", data:"BANCOOB"},
	{label:"Banco do Brasil", data:"BANCO_DO_BRASIL"},
	{label:"Banco BRB", data: "BANCO_BRB"},
	{label:"Banco BTG Pactual", data: "BANCO_BTG_PACTUAL"},
	{label:"Banco do Nordeste", data:"BANCO_DO_NORDESTE"},
	{label:"Banco ITI", data: "BANCO_ITI"},
	{label:"Banco Mercantil", data:"BANCO_MERCANTIL"},
	{label:"Banco Original", data:"BANCO_ORIGINAL"},
	{label:"Banco Real", data:"BANCO_REAL"},
	{label:"Banco Safra", data: "BANCO_SAFRA"},
	{label:"Bradesco", data:"BRADESCO"},
	{label:"Caixa Econômica", data:"CAIXA_ECONOMICA"},
	{label:"Cora", data:"CORA"},
	{label:"C6 Bank", data:"C6_BANK"},
	{label:"Digio", data:"DIGIO"},
	{label:"HSBC", data:"HSBC"},
	{label:"Inter", data:"INTER"},
	{label:"Itaú", data:"ITAU"},
	{label: "Mercado Pago", data: "MERCADO_PAGO" },
	{label:"Neon", data:"NEON"},
	{label:"Next", data:"NEXT"},
	{label:"Nubank", data:"NUBANK"},
	{label:"Pag Seguro", data:"PAG_SEGURO"},
	{label:"PicPay", data:"PICPAY"},
	{label:"Santander", data:"SANTANDER"},
	{label:"Sicoob", data:"SICOOB"},
	{label:"Sicredi", data:"SICRED"},
	{label:"Sudameris", data:"SUDAMERIS"},
	{label:"Votorantim", data:"VOTORANTIM"},
	{label:"Wirecard", data:"WIRECARD"},
	{label:"XP Investimentos", data:"XP_INVESTIMENTOS"},
	{label: "Sofisa", data: "SOFISA" }
]

export const STATUS_CONTA = [
	{ label: "Ativo", data: "ATIVO" },
	{ label: "Inativo", data: "INATIVO" }
]

export const STATUS_LANCAMENTO = [
	{label:"Aberto", data:"ABERTO"},
	{label:"Efetuado", data:"EFETUADO"},
	{label:"Cancelado", data:"CANCELADO"},
	{label:"Devolvido", data:"DEVOLVIDO"}
];

export const TIPO_LANCAMENTO = [
	{label:"Boleto", data:"BOLETO"},
	{label:"Cheque", data:"CHEQUE"},
	{label:"Cartão de Crédito", data:"CARTAO_CREDITO"},
	{label:"Cartão de Débito", data:"CARTAO_DEBITO"},
	{label:"Débito em Conta", data:"DEBITO_CONTA"},
	{label:"Deposito em Conta", data:"DEPOSITO_CONTA"},
	{label:"Dinheiro", data:"DINHEIRO"},
	{label:"Não Informado", data: "NAO_INFORMADO"}
];

export const STATUS_CONTA_RECEBER_PAGAR = [
	{label:"Provisória", data:"PROVISORIA"},
	{label:"Aberta", data:"ABERTA"},
	{label:"Paga", data:"PAGA"},
	{label:"Cancelada", data:"CANCELADA"}
]

export const STATUS_LISTA_ESPERA_PRETENDENTES = [
	{ label: "Em Espera", data: "EM_ESPERA" },
	{ label: "Concluído", data: "CONCLUIDO" },
	{ label: "Cancelado", data: "CANCELADO" }
]

export const TIPO_CONTA = [
	{label: "Conta Corrente", data: "CONTA_CORRENTE"},
	{label: "Conta Poupança", data: "CONTA_POUPANCA"}
]

export const STATUS_CONTATO = [
	{label: "Em Andamento", data: "EM_ANDAMENTO"}, 
	{label: "Concluído", data: "CONCLUIDO"}
]

export const STATUS_PAGAMENTO = [
	{label: "Pago", data: "PAGO"}, 
	{label: "Em Aberto", data: "EM_ABERTO"},
	{label: "Cancelado", data: "CANCELADO"}
]

export const ESTADO_CIVIL = [
	{label: "Solteiro", data: "SOLTEIRO"},
	{label: "Casado", data: "CASADO"},
	{label: "Divorciado", data: "DIVORCIADO"},
	{label: "Viúvo", data: "VIUVO"},
	{label: "União Estável", data: "UNIAO_ESTAVEL"}
]

export const TIPOS_CONTATOS = [
	{ label: "Residencial", data: "RESIDENCIAL" },
	{ label: "Comercial", data: "COMERCIAL" }
]

export const TIPO_LOCACAO = [
	{ label: "Residencial", data: "RESIDENCIAL" },
	{ label: "Comercial", data: "COMERCIAL" },
	{ label: "Residencial/Comercial", data: "RESIDENCIAL_COMERCIAL" }
]

export const TIPO_ALUGUEL = [
	{ label: "Garantido", data: "GARANTIDO" },
	{ label: "Não Garantido", data: "NAO_GARANTIDO" }
]

export const CATEGORIA_CLIENTE = [
	{ label: "Proprietários/Compradores", data: "PROPRIETARIO_COMPRADOR" },
	{ label: "Proprietários", data: "PROPRIETARIO" },
	{ label: "Compradores", data: "COMPRADOR" },
	{ label: "Pretendentes", data: "PRETENDENTE" }
]

export const PERFIL_CLIENTE_ALUGUEL = [
	{label: "Proprietários/Locatários", data: "PROPRIETARIO_LOCATARIO"},
	{label: "Proprietários", data: "PROPRIETARIO"},
	{label: "Beneficiários", data: "BENEFICIARIO"},
	{label: "Locatários", data: "LOCATARIO"},
	{label: "Fiadores", data: "FIADOR"},
	{label: "Pretendentes", data: "PRETENDENTE"}
]

//CONFIGURA A TELA INICIAL DE INDICADORES
export const INICIO_WIDGETS = [
	{label: "Gráficos", data: "GRAFICOS"},
	{label: "Tabelas", data: "TABELAS"},
	{label: "Imóveis", data: "IMOVEIS_ALUGUEL"},
]

export const TIPOS_RELATORIO_COMISSOES = [
	{ label: "Relatório de Comissoes a Pagar", data: "COMISSOES_A_PAGAR" },
	{ label: "Relatório de Comissoes Pagas", data: "COMISSOES_PAGAS" }
]

export const TIPOS_MIDIA = [
	{ label: "TV", data: "TV" },
	{ label: "Panfletos", data: "PANFLETOS" },
	{ label: "Outdoor", data: "OUTDOOR" },
	{ label: "Indicação", data: "INDICACAO" },
	{ label: "Internet", data: "INTERNET" },
	{ label: "Facebook", data: "FACEBOOK" },
	{ label: "Instagram", data: "INSTAGRAM" },
	{ label: "Twitter", data: "TWITTER" },
	{ label: "Rádio", data: "RADIO" },
	{ label: "Placa", data: "PLACA" },
	{ label: "Ligação Direta", data: "LIGACAO_DIRETA" },
	{ label: "Telão", data: "TELAO" },
	{ label: "Google", data: "GOOGLE" },
	{ label: "Viva Real", data: "VIVA_REAL" },
	{ label: "Zap", data: "ZAP" },
	{ label: "OLX", data: "OLX" },
	{ label: "Outros", data: "OUTRO" }
];

export const TIPO_VISTORIA = [
	{ label: "Entrada", data: "ENTRADA" },
	{ label: "Entrada - Complemento", data: "ENTRADA_COMPLEMENTO" },
	{ label: "Saída", data: "SAIDA" },
	{ label: "Saída - Complemento", data: "SAIDA_COMPLEMENTO" }
];

export const STATUS_VISTORIA = [
  { label: "Agendada", data: "AGENDADO" },
  { label: "Concluída", data: "CONCLUIDO" },
  { label: "Cancelada", data: "CANCELADO" },
];

export const ESTADO_VISTORIA = [
	{ label: "Novo", data: "NOVO" },
	{ label: "Bom", data: "BOM" },
	{ label: "Regular", data: "REGULAR" },
	{ label: "Ruim", data: "RUIM" }
];

export const STATUS_RECIBO_REPASSE = [
    { label: "Pago", data: "PAGO" },
    { label: "Em Aberto", data: "EM_ABERTO" },
    { label: "Cancelado", data: "CANCELADO_INATIVACAO" }
]

export const PERFIL_CLIENTE_ITEM_RECIBO = [
	{ label: "Proprietário", data: "PROPRIETARIO" },
	{ label: "Locatário", data: "LOCATARIO" }
]

export const TIPO_ITEM_RECIBO = [
    { label: "Débito", data: "DEBITO" },
    { label: "Crédito", data: "CREDITO" }
]

export const FORMA_RECEBIMENTO = [
    { label: "Caixa da Imobiliária", data: "CAIXA_DA_IMOBILIARIA" },
	{ label: "Transferência Bancária", data: "TRANSFERENCIA_BANCARIA" },
	{ label: "Boleto", data: "BOLETO" },
	{ label: "Cartão de Crédito", data: "CARTAO_DE_CREDITO" },
	{ label: "Acordo", data: "ACORDO" }
]

export const FORMA_PAGAMENTO = [
	{ label: "Pago na Imobiliária", data: "RECEBIMENTO_IMOBILIARIA" },
	{ label: "Depósito em Conta", data: "DEPOSITO_EM_CONTA" },
	{ label: "Pagamento por PIX", data: "PAGAMENTO_PIX" },
	{ label: "Acordo", data: "ACORDO" },
]

export const STATUS_CAIXA = [
	{ label: "Aberto", data: "ABERTO" },
	{ label: "Fechado", data: "FECHADO" }
]

export const FORMA_PAGAMENTO_LANCAMENTO_CAIXA = [
	{ label: "Cheque", data: "CHEQUE" },
	{ label: "Dinheiro", data: "DINHEIRO" }
]

export const DETALHES_PAGAMENTO_LANCAMENTO_CAIXA = [
	{ label: "Dinheiro", data: "DINHEIRO" },
	{ label: "Cheque", data: "CHEQUE" },
	{ label: "Cheques", data: "CHEQUES" }
]

export const FORMA_ALUGUEL = [
	{ label: "Aluguel Vencido - 1º Vencimento 30 dias após o início", data: "VENCIDO_30_DIAS" },
	{ label: "Aluguel Adiantado - 1º Vencimento no dia do início", data: "ADIANTADO" },
	{ label: "Aluguel Proporcional - Proporcional até o fim do primeiro mês", data: "PROPORCIONAL" },
	{ label: "Aluguel cobrado no 5º dia útil", data: "DIA_UTIL_MES" },
	{ label: "Aluguel Periódico", data: "PERIODICO" }
	//{ label: "", data: "VENCIDO_ULTIMO_DIA" }
];

export const PERIDIOCIDADE_ALUGUEL = [
	{ label: "Bimistral", data: "BIMESTRAL" },
	{ label: "Trimestral", data: "TRIMESTRAL" },
	{ label: "Semestral", data: "SEMESTRAL" },
	{ label: "Anual", data: "ANUAL" }
];

export const INDICE_REAJUSTE = [
	{ label: "IGPM/FGV", data: "IGPM_FGV" },
	{ label: "IPC/FIPE", data: "IPC_FIPE" },
	{ label: "INPC/IBGE", data: "INPC_IBGE" },
	{ label: "IGP/FGV", data: "IGP_FGV" },
	{ label: "IPC/FGV", data: "IPC_FGV" },
	{ label: "IPCA", data: "IPCA" },
];

export const REGRA_REPASSE = [
	{ label: "Dia fixo a cada mês", data: "DIA_FIXO" },
	{ label: "Dias após o vencimento", data: "DIAS_CORRIDOS" }
];

export const STATUS_IMOVEL = [
	{ label: "Disponível", data: "DISPONIVEL" },
	{ label: "Reservado", data: "RESERVADO" },
	{ label: "Indisponível", data: "INDISPONIVEL" },
	{ label: "Locado", data: "LOCADO" },
	{ label: "Em Desocupação", data: "EM_DESOCUPACAO" },
	{ label: "Arquivado", data: "ARQUIVADO" },
	{ label: "Vendido", data: "VENDIDO" }
];

export const NOME_PORTAL = [
	{ label: "Campainha", data: "CAMPAINHA" },
	{ label: "ImovelWeb", data:"IMOVEL_WEB" },
	{ label: "Moving", data: "MOVING" },
	{ label: "OLX", data: "OLX" },
	{ label: "Viva Real", data: "VIVA_REAL" },
	{ label: "Zap", data: "ZAP" },
	{ label: "Grupo OLX", data: "GRUPO_OLX"}
];

export const PORTAIS_COM_DESTAQUE = [
	"OLX",
	"VIVA_REAL",
	"ZAP",
	"GRUPO_OLX"
];

export const QUANTIDADE_QUARTOS_IMOVEL = [
	{ label: "01", data: 1 },
	{ label: "02", data: 2 },
	{ label: "03", data: 3 },
	{ label: "04", data: 4 },
	{ label: "05+", data: 5 }
];

export const QUANTIDADE_SUITES_IMOVEL = [
	{ label: "01", data: 1 },
	{ label: "02", data: 2 },
	{ label: "03", data: 3 },
	{ label: "04", data: 4 },
	{ label: "05+", data: 5 }
];

export const PERFIS_USUARIO_PESQUISA = [
	{ label: "Usuários", data: undefined },
	{ label: "Parceiros", data: "PARCEIRO" }
];

export const PERFIS_USUARIO = [
	{ label: "Administrador", data: "ADMINISTRADOR" },
	{ label: "Gerente", data: "GERENTE" },
	{ label: "Corretor", data: "CORRETOR" },
	{ label: "Secretário", data: "SECRETARIO" },
	{ label: "Parceiro", data: "PARCEIRO" }
];

export const DIAS_DA_SEMANA = [
	{ label: "Segunda-Feira", data: "SEGUNDA" },
	{ label: "Terça-Feira", data: "TERCA" },
	{ label: "Quarta-Feira", data: "QUARTA" },
	{ label: "Quinta-Feira", data: "QUINTA" },
	{ label: "Sexta-Feira", data: "SEXTA" },
	{ label: "Sábado", data: "SABADO" },
	{ label: "Domingo", data: "DOMINGO" }
];

export const FORMA_PAGAMENTO_SEGURO_INCENDIO = [
	{label:"Sem seguro", data:"SEM_SEGURO"},
	{label:"A vista", data:"A_VISTA"},
	{label:"2x", data:"DUAS_VEZES"},
	{label:"3x", data:"TRES_VEZES"},
	{label:"4x", data:"QUATRO_VEZES"},
	{label:"5x", data:"CINCO_VEZES"},
	{label:"6x", data:"SEIS_VEZES"},
	{label:"7x", data:"SETE_VEZES"},
	{label:"8x", data:"OITO_VEZES"},
	{label:"9x", data:"NOVE_VEZES"},
	{label:"10x", data:"DEZ_VEZES"},
	{label:"11x", data:"ONZE_VEZES"},
	{label:"12x", data:"DOZE_VEZES"},
];

export const TIPO_GARANTIA = [
	{label: "Não especificada", data: undefined},
	{label:"Caução", data:"CAUCAO"},
	{label:"Fiador", data:"FIADOR"},
	{label:"Seguro Fiança", data:"SEGURO_FIANCA"},
	{label:"Título de Capitalização", data:"TITULO_CAPITALIZACAO"},
	{label:"Carta Fiança", data:"CARTA_FIANCA"},
	{label:"PDG", data:"PDG"}
];

export const TIPO_GARANTIA_PESQUISA = [
	{ label: "Todos", data: undefined },
	{ label: "Não especificada", data: "NAO_ESPECIFICADA" },
	{ label: "Caução", data: "CAUCAO" },
	{ label: "Fiador", data: "FIADOR" },
	{ label: "Seguro Fiança", data: "SEGURO_FIANCA" },
	{ label: "Título de Capitalização", data: "TITULO_CAPITALIZACAO" },
	{ label: "Carta Fiança", data: "CARTA_FIANCA" },
	{label:"PDG", data:"PDG"}
];

export const FORMA_PAGAMENTO_CONTA_RECEBER_PAGAR = [
	{label:"À Vista", data:"VISTA"},
	{label: "Parcelado", data: "PARCELADO"}
];

export const TIPO_GRUPO = [
	{label:"Despesa", data:"DESPESA"},
	{label:"Receita", data:"RECEITA"}
];

export const TIPOS_FORMULARIO = [
	{ label: "Aluguel", data: "ALUGUEL" },
	{ label: "Venda", data: "VENDA" },
	{ label: "Imóvel de Venda", data: "IMOVEL_VENDA" },
	{ label: "Imóvel de Aluguel", data: "IMOVEL_ALUGUEL" }
];

export const CANAIS_COBRANCAS = [
	{ label: "Email", data: "EMAIL" },
	{ label: "SMS", data: "SMS" },
	{ label: "Carta de cobrança", data: "CARTA_DE_COBRANCA" },
	{ label: "Ligação", data: "LIGACAO" },
	{ label: "WhatsApp", data: "WHATSAPP" },
	{ label: "Outros", data: "OUTROS" }
]

export const TIPOS_COBRANCAS = [
	{ label: "Cobrança Manual", data: "COBRANCA_MANUAL" },
	{ label: "Cobranca Automática", data: "COBRANCA_AUTOMATICA" }
]

export const TIPO_COBRANCA_AUTO = [
	{ label: 'Avisos Prévios', data: 'AVISO_PREVIO' },
	{ label: 'Avisos após Vencimento', data: 'AVISO_APOS_VENCIMENTO' },
	{ label: 'Avisos na Data de Vencimento', data: 'AVISO_NO_DIA_DO_VENCIMENTO'}
]

export const TIPOS_COMUNICACAO = [
	{ label: 'Todos', data: 'TODOS' },
	{label: 'Email Aniversário', data: 'ANIVERSARIO_PROPRIETARIO'},
	{label: 'Aviso de IPTU', data: 'AVISO_IPTU'},
	{label: 'Avisos de Pagamento de Aluguel', data: 'AVISO_PAGAMENTO_ALUGUEL'},
	{label: 'Avisos de Pagamento de Repasse', data: 'AVISO_PAGAMENTO_REPASSE'},
	{label: 'Avisos de Reajuste Próximo', data: 'AVISO_REAJUSTE'},
	{label: 'Avisos de Renovação Próxima', data: 'AVISO_RENOVACAO'},
	{label: 'Avisos de Cobrança Manual', data: 'COBRANCA_MANUAL'},
	{label: 'Avisos de Cobrança Prévios', data: 'AVISO_PREVIO'},
	{label: 'Avisos de Cobrança Após Vencimento', data: 'AVISO_APOS_VENCIMENTO'},
	{label: 'Avisos na Data de Vencimento', data: 'AVISO_NO_DIA_DO_VENCIMENTO'},
	{label: 'Acompanhamento de Imóvel', data: 'DESEMPENHO_IMOVEL'},
	{label: 'Pesquisa de satisfação', data: 'PESQUISA_SATISFACAO'}
]

export const TIPO_DOCUMENTO_CONTA = [
	{ label: 'Não informado', data: null },
	{ label: 'Recibo', data: 'RECIBO' },
	{ label: 'Contrato', data: 'CONTRATO' },
	{ label: 'Cupom Fiscal', data: 'CUPOM_FISCAL' },
	{ label: 'NF-e', data: 'NF_E'},
	{ label: 'NFS-e', data: 'NFS_E' }
]

export const TIPO_BOLETO = [
	{ label: 'Boleto Avulso', data: 'OUTROS' },
	{ label: 'Boleto de Acordo', data: 'ACORDO' }
]

export const TIPO_BOLETO_REMESSA = [
	{ label: 'Todos', data: 'TODOS' },
	{ label: 'Boleto Avulso', data: 'BOLETO_AVULSO' },
	{ label: 'Boleto de Acordo', data: 'BOLETO_ACORDO' },
	{ label: 'Boleto de Aluguel', data: 'BOLETO_ALUGUEL' },
]

export const TIPO_SIGNATARIO_ALUGUEL = [
	{ label: 'Locador(Proprietário)', data: 'LOCADOR' },
	{ label: 'Locatario', data: 'LOCATARIO' },
	{ label: 'Testemunha', data: 'TESTEMUNHA' },
	{ label: 'Fiador', data: 'FIADOR' },
	{ label: 'Representante Imobiliaria', data: 'GESTOR' }
]

export const TIPO_SIGNATARIO_VENDA = [
	{ label: 'Vendedor(Proprietario)', data: 'VENDEDOR' },
	{ label: 'Comprador', data: 'COMPRADOR' },
	{ label: 'Testemunha', data: 'TESTEMUNHA' },
	{ label: 'Representante Imobiliaria', data: 'GESTOR' }
]

export const TIPO_SIGNATARIO_IMOVEL_ALUGUEL = [
	{ label: 'Locador(Proprietário)', data: 'LOCADOR' },
	{ label: 'Representante Imobiliaria', data: 'GESTOR' }
]

export const STATUS_ASSINATURA = [
	{ label: 'Nova Assinatura', data: 'NOVA_ASSINATURA'},
	{ label: 'Em processo', data: 'EM_PROCESSO' },
	{ label: 'Finalizada', data: 'FINALIZADA' },
	{ label: 'Cancelada', data: 'CANCELADA' }
]

export const STATUS_ASSINATURA_SIGNATARIO = [
	{ label: 'Pendente', data: 'EM_ESPERA' },
	{ label: 'Concluída', data: 'CONCLUIDA' }
]

export const STATUS_ATENDIMENTO = [
	{ label: 'Em espera', data: 'EM_ESPERA' },
	{ label: 'Cancelado', data: 'CANCELADO' },
	{ label: 'Concluído', data: 'CONCLUIDO' }
]

export const ESTAGIO_ATENDIMENTO = [
	{ label: 'Pre Cadastro', data: 'PRE_CADASTRO' },
	{ label: 'Criacao de Perfil', data: 'CRIACAO_PERFIL' },
	{ label: 'Seleção de Imóveis', data: 'SELECAO_IMOVEIS' },
	{ label: 'Visitas', data: 'VISITAS' },
	{ label: 'Propostas', data: 'PROPOSTAS' },
	{ label: 'Conclusão', data: 'CONCLUSAO' }
]

export const TIPO_PIX = [
	{ label: 'Telefone', data: 'TELEFONE' },
	{ label: 'Email', data: 'EMAIL' },
	{ label: 'CPF', data: 'CPF' },
	{ label: 'CNPJ', data: 'CNPJ' },
	{ label: 'Aleatória', data: 'ALEATORIA' }
]

export const MODULO_NOTIFICACAO = [
	{ label: 'Contrato de Aluguel', data: 'ALUGUEL_CONTRATO' },
	{ label: 'Cliente de Aluguel', data: 'ALUGUEL_CLIENTE' },
	{ label: 'Imovel de Aluguel', data: 'ALUGUEL_IMOVEL' },
	{ label: 'Contrato de Venda', data:'VENDA_CONTRATO' },
	{ label: 'Cliente de Venda', data: 'VENDA_CLIENTE' },
	{ label: 'Imovel de Venda', data: 'VENDA_IMOVEL' }
]

export const TIPO_DE_NOTIFICACAO = [
	{ label: 'Reajuste de Contrato', data: 'REAJUSTE_CONTRATO' },
	{ label: 'Renovação de Contrato', data: 'RENOVACAO_CONTRATO' },
	{ label: 'Finalização de Contrato', data: 'FINALIZACAO_CONTRATO' },
	{ label: 'Retorno de Contato', data: 'RETORNO_CONTATO' },
	{ label: 'Aceitação de Proposta', data: 'PROPOSTA_ACEITA' },
	{ label: 'Agendamento de Vistoria', data: 'VISTORIA_AGENDADA' },
	{ label: 'Vistoria Concluída', data: 'VISTORIA_CONCLUIDA' },
	{ label: 'Recibos não registrados', data: 'RECIBOS_NAO_REGISTRADOS' }
]

export const TIPO_RETORNO = [
	{ label: 'Cobrança', data: 'COBRANCA' },
	{ label: 'Pagamento', data: 'PAGAMENTO' }
]

export const TIPO_ACAO_PROPOSTA = [
	{ label: 'Abertura', data: 'ABERTURA' },
	{ label: 'Aguardando assinatura/Assinatura enviada', data: 'AGUARDANDO_ASSINATURA' },
	{ label: 'Cancelado', data: 'CANCELADO' }
]

export const AUTH_MODE_ZAP_SIGN = [
	{ label: 'Assinatura na tela', data: 'ASSINATURA_TELA' },
	{ label: 'Token por E-mail', data: 'TOKEN_EMAIL' },
	{ label: 'Assinatura na Tela com token por E-mail', data: 'ASSINATURA_TELA_TOKEN_EMAIL' },
	{ label: 'Token por SMS', data: 'TOKEN_SMS' },
	{ label: 'Assinatura na tela com token por SMS', data: 'ASSINATURA_TELA_TOKEN_SMS' },
	{ label: 'Token por whatsapp', data: 'TOKEN_WHATSAPP' },
	{ label: 'Assinatura na tela com token por whatsapp', data: 'ASSINATURA_TELA_TOKEN_WHATSAPP' },
	{ label: 'Certificado digital', data: 'CERTIFICADO_DIGITAL' },
	{ label: 'CPF', data: 'CPF' },
	{ label: 'Sem atenticação', data: 'SEM_AUTENTICACAO' }
]

export const TIPO_REGISTRO_CORA = [
	{ label: 'Crédito', data: 'CREDIT' },
	{ label: 'Débito', data: 'DEBIT' }
]

export const TIPO_TRANSACAO_CORA = [
	{ label: 'Transferência', data: 'TRANSFER' },
	{ label: 'Pagamento', data: 'PAYMENT' },
	{ label: 'Pix', data: 'PIX' },
	{ label: 'Taxas Cora', data: 'FEE' },
	{ label: 'Terminal de Pagamento', data: 'BANK_DOMICILE' },
	{ label: 'Subscrição', data: 'SUBSCRIPTION' }
]

export const TIPO_TRANSACAO_ASAAS = [
		{ label: 'Recarga de cartão Asaas', data: 'ASAAS_CARD_RECHARGE' },
		{ label: 'Estorno da recarga de cartão', data: 'ASAAS_CARD_RECHARGE_REVERSAL' },
		{ label: 'Transação efetuada com o cartão Asaas', data: 'ASAAS_CARD_TRANSACTION' },
		{ label: 'Cashback recebido com o cartão Asaas', data: 'ASAAS_CARD_CASHBACK' },
		{ label: 'Taxa para transação efetuada com o cartão Asaas', data: 'ASAAS_CARD_TRANSACTION_FEE' },
		{ label: 'Estorno de taxa para transação efetuada com o cartão Asaas', data: 'ASAAS_CARD_TRANSACTION_FEE_REFUND' },
		{ label: 'Estorno parcial de transação efetuada com o cartão Asaas', data: 'ASAAS_CARD_TRANSACTION_PARTIAL_REFUND' },
		{ label: 'Cancelamento do estorno parcial de transação efetuada com o cartão Asaas', data: 'ASAAS_CARD_TRANSACTION_PARTIAL_REFUND_CANCELLATION' },
		{ label: 'Estorno de transação efetuada com o cartão Asaas', data: 'ASAAS_CARD_TRANSACTION_REFUND' },
		{ label: 'Cancelamento do estorno de transação efetuada com o cartão Asaas', data: 'ASAAS_CARD_TRANSACTION_REFUND_CANCELLATION' },
		{ label: 'Estorno taxa de Parcelamento ASAAS Money', data: 'ASAAS_MONEY_PAYMENT_ANTICIPATION_FEE_REFUND' },
		{ label: 'Bloqueio de saldo comprometido com pagamento Asaas Money', data: 'ASAAS_MONEY_PAYMENT_COMPROMISED_BALANCE' },
		{ label: 'Cancelamento do bloqueio de saldo comprometido com pagamento Asaas Money', data: 'ASAAS_MONEY_PAYMENT_COMPROMISED_BALANCE_REFUND' },
		{ label: 'Taxa de financiamento ASAAS Money', data: 'ASAAS_MONEY_PAYMENT_FINANCING_FEE' },
		{ label: 'Estorno taxa de financiamento ASAAS Money', data: 'ASAAS_MONEY_PAYMENT_FINANCING_FEE_REFUND' },
		{ label: 'Cashback - ASAAS MONEY', data: 'ASAAS_MONEY_TRANSACTION_CASHBACK' },
		{ label: 'Estorno de cashback - ASAAS MONEY', data: 'ASAAS_MONEY_TRANSACTION_CASHBACK_REFUND' },
		{ label: 'Chargeback transação Asaas Money', data: 'ASAAS_MONEY_TRANSACTION_CHARGEBACK' },
		{ label: 'Estorno chargeback transação Asaas Money', data: 'ASAAS_MONEY_TRANSACTION_CHARGEBACK_REVERSAL' },
		{ label: 'Pagamento de conta', data: 'BILL_PAYMENT' },
		{ label: 'Cancelamento do pagamento de conta', data: 'BILL_PAYMENT_CANCELLED' },
		{ label: 'Estorno do pagamento de conta', data: 'BILL_PAYMENT_REFUNDED' },
		{ label: 'Taxa de pagamento de conta', data: 'BILL_PAYMENT_FEE' },
		{ label: 'Cancelamento da taxa de pagamento de conta', data: 'BILL_PAYMENT_FEE_CANCELLED' },
		{ label: 'Bloqueio de saldo devido ao chargeback de cobrança', data: 'CHARGEBACK' },
		{ label: 'Cancelamento do bloqueio de saldo devido ao chargeback', data: 'CHARGEBACK_REVERSAL' },
		{ label: 'Estorno da taxa para negativação da cobrança ou Pix', data: 'CHARGED_FEE_REFUND' },
		{ label: 'Valor em recebíveis reservado', data: 'CONTRACTUAL_EFFECT_SETTLEMENT' },
		{ label: 'Estorno do valor em recebíveis reservado', data: 'CONTRACTUAL_EFFECT_SETTLEMENT_REVERSAL' },
		{ label: 'Crédito', data: 'CREDIT' },
		{ label: 'Taxa de consulta Serasa', data: 'CREDIT_BUREAU_REPORT' },
		{ label: 'Crédito de liquidação de comissão de parceiros', data: 'CUSTOMER_COMMISSION_SETTLEMENT_CREDIT' },
		{ label: 'Débito de liquidação de comissão de parceiros', data: 'CUSTOMER_COMMISSION_SETTLEMENT_DEBIT' },
		{ label: 'Débito', data: 'DEBIT' },
		{ label: 'Estorno de débito', data: 'DEBIT_REVERSAL' },
		{ label: 'Encargos sobre renegociação', data: 'DEBT_RECOVERY_NEGOTIATION_FINANCIAL_CHARGES' },
		{ label: 'Estorno por campanha promocional na tarifa', data: 'FREE_PAYMENT_USE' },
		{ label: 'Transferência da conta Asaas', data: 'INTERNAL_TRANSFER_CREDIT' },
		{ label: 'Transferência para a conta Asaas', data: 'INTERNAL_TRANSFER_DEBIT' },
		{ label: 'Estorno de transferência para a conta Asaas', data: 'INTERNAL_TRANSFER_REVERSAL' },
		{ label: 'Taxa de emissão da nota fiscal de serviço', data: 'INVOICE_FEE' },
		{ label: 'Cobrança parcialmente recebida', data: 'PARTIAL_PAYMENT' },
		{ label: 'Taxa para cancelamento de negativação de cobrança', data: 'PAYMENT_DUNNING_CANCELLATION_FEE' },
		{ label: 'Taxa para negativação de cobrança', data: 'PAYMENT_DUNNING_RECEIVED_FEE' },
		{ label: 'Taxa para negativação em dinheiro de cobrança', data: 'PAYMENT_DUNNING_RECEIVED_IN_CASH_FEE' },
		{ label: 'Taxa para negativação de cobrança', data: 'PAYMENT_DUNNING_REQUEST_FEE' },
		{ label: 'Taxa de boleto, cartão ou Pix', data: 'PAYMENT_FEE' },
		{ label: 'Estorno da taxa de boleto, cartão ou Pix', data: 'PAYMENT_FEE_REVERSAL' },
		{ label: 'Taxa de mensageria de fatura', data: 'PAYMENT_MESSAGING_NOTIFICATION_FEE' },
		{ label: 'Cobrança recebida', data: 'PAYMENT_RECEIVED' },
		{ label: 'Bloqueio de saldo por custódia', data: 'PAYMENT_CUSTODY_BLOCK' },
		{ label: 'Desbloqueio de saldo por custódia', data: 'PAYMENT_CUSTODY_BLOCK_REVERSAL' },
		{ label: 'Cancelamento do estorno de fatura', data: 'PAYMENT_REFUND_CANCELLED' },
		{ label: 'Estorno de fatura', data: 'PAYMENT_REVERSAL' },
		{ label: 'Taxa de notificação por SMS de cobrança', data: 'PAYMENT_SMS_NOTIFICATION_FEE' },
		{ label: 'Taxa de notificação por mensagem instantânea de cobrança', data: 'PAYMENT_INSTANT_TEXT_MESSAGE_FEE' },
		{ label: 'Taxa de notificação por voz', data: 'PHONE_CALL_NOTIFICATION_FEE' },
		{ label: 'Transferência via Pix recebida', data: 'PIX_TRANSACTION_CREDIT' },
		{ label: 'Taxa de transferência Pix recebida', data: 'PIX_TRANSACTION_CREDIT_FEE' },
		{ label: 'Estorno de recebimento via Pix', data: 'PIX_TRANSACTION_CREDIT_REFUND' },
		{ label: 'Cancelamento de estorno de recebimento via Pix', data: 'PIX_TRANSACTION_CREDIT_REFUND_CANCELLATION' },
		{ label: 'Transação via Pix', data: 'PIX_TRANSACTION_DEBIT' },
		{ label: 'Taxa para Pix', data: 'PIX_TRANSACTION_DEBIT_FEE' },
		{ label: 'Estorno de transação via Pix', data: 'PIX_TRANSACTION_DEBIT_REFUND' },
		{ label: 'Taxa de envio de boletos via Correios', data: 'POSTAL_SERVICE_FEE' },
		{ label: 'Taxa de emissão da nota fiscal de produto emitida via Base ERP', data: 'PRODUCT_INVOICE_FEE' },
		{ label: 'Taxa de emissão da nota fiscal de consumidor emitida via Base ERP', data: 'CONSUMER_INVOICE_FEE' },
		{ label: 'Desconto na taxa', data: 'PROMOTIONAL_CODE_CREDIT' },
		{ label: 'Estorno do desconto na taxa', data: 'PROMOTIONAL_CODE_DEBIT' },
		{ label: 'Antecipação de parcelamento ou cobrança', data: 'RECEIVABLE_ANTICIPATION_GROSS_CREDIT' },
		{ label: 'Baixa da parcela ou antecipação', data: 'RECEIVABLE_ANTICIPATION_DEBIT' },
		{ label: 'Taxa de antecipação de parcelamento ou cobrança', data: 'RECEIVABLE_ANTICIPATION_FEE' },
		{ label: 'Baixa da parcela ou antecipação', data: 'RECEIVABLE_ANTICIPATION_PARTNER_SETTLEMENT' },
		{ label: 'Cancelamento do estorno de fatura', data: 'REFUND_REQUEST_CANCELLED' },
		{ label: 'Taxa de realização de estorno de fatura', data: 'REFUND_REQUEST_FEE' },
		{ label: 'Cancelamento da taxa de realização de estorno de fatura', data: 'REFUND_REQUEST_FEE_REVERSAL' },
		{ label: 'Estorno', data: 'REVERSAL' },
		{ label: 'Transferência para conta bancária', data: 'TRANSFER' },
		{ label: 'Taxa de transferência para conta bancária', data: 'TRANSFER_FEE' },
		{ label: 'Estorno de transferência para conta bancária', data: 'TRANSFER_REVERSAL' },
		{ label: 'Recarga de celular', data: 'MOBILE_PHONE_RECHARGE' },
		{ label: 'Estorno de recarga de celular', data: 'REFUND_MOBILE_PHONE_RECHARGE' },
		{ label: 'Cancelamento de recarga de celular', data: 'CANCEL_MOBILE_PHONE_RECHARGE' },
		{ label: 'Taxa de notificação por WhatsApp', data: 'INSTANT_TEXT_MESSAGE_FEE' },
		{ label: 'Estorno de cartão Asaas', data: 'ASAAS_CARD_BALANCE_REFUND' },
		{ label: 'Taxa de Parcelamento ASAAS Money', data: 'ASAAS_MONEY_PAYMENT_ANTICIPATION_FEE' },
		{ label: 'Bloqueio Judicial', data: 'BACEN_JUDICIAL_LOCK' },
		{ label: 'Desbloqueio Judicial', data: 'BACEN_JUDICIAL_UNLOCK' },
		{ label: 'Transferência Judicial', data: 'BACEN_JUDICIAL_TRANSFER' },
		{ label: 'Taxa de adesão do cartão Elo débito', data: 'ASAAS_DEBIT_CARD_REQUEST_FEE' },
		{ label: 'Taxa de adesão do cartão Elo pré-pago', data: 'ASAAS_PREPAID_CARD_REQUEST_FEE' },
		{ label: 'Crédito de valores para liquidação de efeitos de contrato', data: 'EXTERNAL_SETTLEMENT_CONTRACTUAL_EFFECT_BATCH_CREDIT' },
		{ label: 'Estorno de valores referentes a liquidação de efeitos de contrato', data: 'EXTERNAL_SETTLEMENT_CONTRACTUAL_EFFECT_BATCH_REVERSAL' },
		{ label: 'Pagamento de fatura do cartão Asaas', data: 'ASAAS_CARD_BILL_PAYMENT' },
		{ label: 'Estorno de pagamento de fatura do cartão Asaas', data: 'ASAAS_CARD_BILL_PAYMENT_REFUND' },
		{ label: 'Taxa de criação de contas filhas', data: 'CHILD_ACCOUNT_KNOWN_YOUR_CUSTOMER_BATCH_FEE' },
		{ label: 'Taxa da mensalidade do plano Asaas', data: 'CONTRACTED_CUSTOMER_PLAN_FEE' },
		{ label: 'Taxa de conta inativa', data: 'ACCOUNT_INACTIVITY_FEE' }
	];

export const TIPO_DE_ASSINATURA = [
	{ label: 'Aluguel', data: 'ALUGUEL' },
	{ label: 'Venda', data: 'VENDA' },
	{ label: 'Imovel de Aluguel', data: 'IMOVEL_ALUGUEL' },
	{ label: 'Imovel de Venda', data: 'IMOVEL_VENDA' },
	{ label: 'Vistoria', data: 'VISTORIA' },
	{ label: 'Proposta', data: 'PROPOSTA' }
]

export const EMAIL_REGEX = /^\w+([--_]?\w+)*@\w+([.-]?\w+)*$/;

export const TAMANHO_MAXIMO_LOGO_IMOBILIARIA_EM_BYTES = 1572864;

export const TAMANHO_MAXIMO_IMAGEM_EMAIL_ANIVERSARIO_EM_BYTES = 1572864;

export const TAMANHO_MAXIMO_LOGO_SITE_EM_BYTES = 1572864;

export const TAMANHO_MAXIMO_ARQUIVO_EM_BYTES = 4194304;

// export const TAMANHO_MAXIMO_FORMULARIO_EM_BYTES = 4194304;

export const TAMANHO_MAXIMO_FORMULARIO_EM_BYTES = 20000000;

export const QUANTIDADE_MAXIMA_REPETICAO_BOLETO = 59;